import account from "./account.ftl?raw";
import api from "./api.ftl?raw";
import cart from "./cart.ftl?raw";
import checkout from "./checkout.ftl?raw";
import contact from "./contact.ftl?raw";
import countries from "./countries.ftl?raw";
import email from "./email.ftl?raw";
import footer from "./footer.ftl?raw";
import header from "./header.ftl?raw";
import localeSelector from "./locale_selector.ftl?raw";
import makePersonal from "./make_personal.ftl?raw";
import menu from "./menu.ftl?raw";
import misc from "./misc.ftl?raw";
import orderConfirmation from "./order_confirmation.ftl?raw";
import payment from "./payment.ftl?raw";
import product from "./product.ftl?raw";
import productList from "./product_list.ftl?raw";
import products from "./products.ftl?raw";
import swatches from "./swatches.ftl?raw";
import skus from "./skus.ftl?raw";

export default [
	account,
	api,
	cart,
	checkout,
	contact,
	countries,
	email,
	footer,
	header,
	localeSelector,
	makePersonal,
	menu,
	misc,
	orderConfirmation,
	payment,
	product,
	productList,
	products,
	swatches,
	skus,
].join("\n");
